import { render, staticRenderFns } from "./kkv-layout.vue?vue&type=template&id=4ecd1398"
import script from "./kkv-layout.vue?vue&type=script&lang=js"
export * from "./kkv-layout.vue?vue&type=script&lang=js"
import style0 from "./kkv-layout.vue?vue&type=style&index=0&id=4ecd1398&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports